import { ChestGameApi, GameMasterApi } from '@/api/backendService';

/**
 * Chests, from both ends.
 *
 * The player half wraps the chest endpoints — read a chest, take one item, take
 * everything. The GM half is the item search the map editor's loot table needs,
 * which lives on the gamemaster items endpoint rather than on chests, because
 * it is the same catalogue every other GM tool picks items from.
 */
class ChestService {
  constructor(api = ChestGameApi, gmApi = GameMasterApi) {
    this.api = api;
    this.gmApi = gmApi;
  }

  /** Every chest currently visible to the player's character. */
  async listChests() {
    return (await this.api.chestChestsList()).data;
  }

  /** One chest and its full manifest. */
  async getChest(chestId) {
    return (await this.api.chestChestsRetrieve(chestId)).data;
  }

  /**
   * Take a single item.
   * @returns the chest as it now stands — empty chests come back `is_active: false`.
   */
  async takeItem(chestId, worldItemId) {
    return (await this.api.chestChestsTakeCreate(chestId, { world_item_id: worldItemId })).data;
  }

  /** Take everything the chest holds. */
  async takeAll(chestId) {
    return (await this.api.chestChestsTakeAllCreate(chestId)).data;
  }

  /**
   * Search the item catalogue for the editor's loot-table picker.
   *
   * @param query  free text matched against name and description
   * @param type   optional ItemType filter
   */
  async searchItems(query = '', type = undefined) {
    const response = await this.gmApi.gamemasterItemsList(
      'name',
      query || undefined,
      type || undefined
    );
    // The endpoint is paginated in some deployments and a bare list in others;
    // normalise so callers never have to care which they got.
    const data = response.data;
    return Array.isArray(data) ? data : (data?.results ?? []);
  }
}

export default new ChestService();
export { ChestService };
